import { GuestActionDto } from "by/gamefactory/cityversetycoon/networking/data/responses/GuestActionDto";
import { Action } from "../Action";
import { GuestActionType } from "by/gamefactory/cityversetycoon/networking/data/responses/GuestActionType";
import { NewsCard } from "./news/NewsCard";
import { NewsType } from "by/gamefactory/cityversetycoon/networking/data/responses/news/NewsType";
import { RaidNewsCard } from "./news/RaidNewsCard";
import { VisitNewsCard } from "./news/VisitNewsCard";
import { StealNewsCard } from "./news/StealNewsCard";

export class NewsAction implements Action {
    public readonly news: NewsCard;

    public constructor(dto: GuestActionDto) {
        if (dto == null) {
            throw new Error("You can't create NewsAction without providing GuestActionDto.");
        }
        if (dto.type != GuestActionType.NEWS) {
            throw new Error(`You can't create NewsAction from GuestActionDto with type equal to ${dto.type}.`);
        }
        if (dto.news == undefined) {
            throw new Error("You can't create NewsAction from GuestActionDto without news value.");
        }
        switch (dto.news.type) {
            case NewsType.RAID:
                this.news = new RaidNewsCard(dto.news);
                break;
            case NewsType.VISIT:
                this.news = new VisitNewsCard(dto.news);
                break;
            case NewsType.STEAL:
                this.news = new StealNewsCard(dto.news);
                break;
            default:
                throw new Error(`Failed to create NewsAction news type ${dto.news.type} not supported.`);
        }
    }

}